// extracted by mini-css-extract-plugin
module.exports = {"title":"other-infor_title__1X0QM","sub_title":"other-infor_sub_title__3emKS","margin":"other-infor_margin__ofQJT"};